module.exports = __webpack_public_path__ + "static/media/Watermeter.063b6faa.png";